export default "__VITE_ASSET__vMyxjLtr__"